
import { Injectable } from '@angular/core';
import * as Constants from '../app.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CacheService } from 'ionic-cache';
import { ElencoCommenti } from '../models/elenco-commenti';
import { Commento } from '../models/commento';
import { TTL_COMMENTS } from 'src/app/app.constants';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Api } from './api/api';
import { FavouriteService } from './favourite.service';
import { Comune } from '../models/comune';
import { ElencoComuni } from '../models/elenco-comuni';
import { environment } from 'src/environments/environment';
import { Category } from '../models/category';
import { Storage } from '@ionic/storage';




export class TAG {
  id?: string;
  type?: string;

  constructor(id: string, type: string) {
    this.id = id;
    this.type = type;
  }
}



@Injectable({
  providedIn: 'root'
})
export class MultiTenantService {


  //elencoComuniService:  Array<Comune>;
  appPages = null;


  elencoComuni: Array<Comune> = null;
  elencoTAG: Array<TAG> = null;

  categoryEvents: Array<Category> = null;
  categoryItinerary: Array<Category> = null;
  categoryAttractor: Array<Category> = null;
  categoryRestaurant: Array<Category> = null;
  categoryAccomodation: Array<Category> = null;

  constructor(
    private storage: Storage,
    private translateService: TranslateService,
    private httpClient: HttpClient,
    private cache: CacheService) {
  }

  getAppPages() {
    return new Promise((resolve, reject) => {
      this.appPages = Constants.APP_PAGES;
      resolve(this.appPages);
    });
  }



  getTAGPages() {
    let elencoTAG = [];
    this.elencoTAG.forEach((element: TAG) => {
      elencoTAG.push({
        title: 'TYPE.' + element.id + '.NAME',
        url: '/tag/pois-list/' + element.id,
      });
    });
    return elencoTAG;
  }

  getComuniPages() {
    let comuni = [];
    this.elencoComuni.forEach((element: Comune) => {
      comuni.push({
        title: 'COMUNI.' + element.id,
        url: '/city/pois-list/' + element.id
      });
    });
    return comuni;
  }

  getCity() {
    return new Promise((resolve, reject) => {

      if ( this.elencoComuni !== null ) {
        resolve(this.elencoComuni);
      } else {
        const path = `${Constants.API_BASE_URL}authority/land/public/${environment.api.tenantId}/cities?excludeDisabled=true`;
        this.loadFromCache(path).subscribe(
          async (res: any) => {
            this.elencoComuni = res;
            resolve(res);
          },
          err => {
            console.error('LoadCity - Lista vuota' + err);
            reject(null);
          }
        );
      }
    });
  }

  getComuneById(cityId) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}authority/city/public/${environment.api.tenantId}/${cityId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          resolve(res);
        },
        err => {
          console.error('LoadCity - Lista vuota');
          reject(null);
        }
      );

    });
  }



  getTags() {
    return new Promise((resolve, reject) => {

      if ( this.elencoTAG !== null ) {
        resolve(this.elencoTAG);
      } else {

        const path = `${Constants.API_BASE_URL}${Constants.BASE_UTILITIES_URL}${Constants.BASE_TAG_URL}${Constants.PUBLIC_URL}?landId=${environment.api.tenantId}&size=100`;
        this.loadFromCache(path).subscribe(
          async (res: any) => {
            this.elencoTAG = new Array<TAG>();
            res.content.forEach(element => {
              this.elencoTAG.push(new TAG(
                element.id,
                element.type)
              )
            });
            resolve(res.content);
          },
          err => {
            reject(null);
          }
        );

      }

    })
  }



  /**
   * Recupera tutte le categorie e lo salva in locale
   */
  getAllCategories() {
    //console.log('getAllCategories');
    return new Promise((resolve, reject) => {


      Promise.all([
        this.getCategoriesEvents(),
        this.getCategoriesItinerary(),
        this.getCategoriesPoi(Constants.POY_TYPE.ACCOMODATION.KEY),
        this.getCategoriesPoi(Constants.POY_TYPE.ATTRACTOR.KEY),
        this.getCategoriesPoi(Constants.POY_TYPE.RESTAURANT.KEY)
      ]).then(res => {
        //console.log('Get all categories');
        resolve(res);
      });


    });
  }



  /**
   * Recupera le categorie degli Itinerari
   */
  getCategoriesItinerary() {
    return new Promise((resolve, reject) => {
      if ( this.categoryItinerary !== null ) {
        resolve(this.categoryItinerary);
      } else {
        const path = `${Constants.API_BASE_URL}/itinerary/categories/public/?landId=${environment.api.tenantId}&page=0&size=1000`;
        this.loadFromCache(path).subscribe(
          async (res: any) => {
            this.categoryItinerary = res.content;
            resolve(res.content);
          },
          err => {
            reject(null);
          }
        );
      }
    });
  }

  
  /**
   * Recupera le categorie degli Eventi
   */
  getCategoriesEvents() {
    return new Promise((resolve, reject) => {
      if ( this.categoryEvents !== null ) {
        resolve(this.categoryEvents);
      } else {
        const path = `${Constants.API_BASE_URL}/event/categories/public/?landId=${environment.api.tenantId}&page=0&size=1000`;
        this.loadFromCache(path).subscribe(
          async (res: any) => {
            this.categoryEvents = res.content;
            resolve(res.content);
          },
          err => {
            reject(null);
          }
        );
      }
    });
  }



  /**
   * 
   * @param idTypePoi 
   * Restituisce una particolare lista di categorie di POI
   */
  getCategoriesPoi(idTypePoi) {
    return new Promise((resolve, reject) => {


      if (Constants.POY_TYPE.ACCOMODATION.KEY == idTypePoi && this.categoryAccomodation !== null) {
        resolve(this.categoryAccomodation);

      } else if (Constants.POY_TYPE.RESTAURANT.KEY == idTypePoi && this.categoryRestaurant !== null) {
        resolve(this.categoryRestaurant);

      } else if (Constants.POY_TYPE.ATTRACTOR.KEY == idTypePoi && this.categoryAttractor !== null) {
        resolve(this.categoryAttractor);

      } else {

        const path = `${Constants.API_BASE_URL}/poi/categories/public/?landId=${environment.api.tenantId}&typeElement=${idTypePoi}&page=0&size=1000`;
        this.loadFromCache(path).subscribe(
          async (res: any) => {
  
            if (Constants.POY_TYPE.ACCOMODATION.KEY == idTypePoi) {
              this.categoryAccomodation = res.content;
            } else if (Constants.POY_TYPE.RESTAURANT.KEY == idTypePoi) {
              this.categoryRestaurant = res.content;
            } else if (Constants.POY_TYPE.ATTRACTOR.KEY == idTypePoi) {
              this.categoryAttractor = res.content;
            }
            resolve(res.content);
          },
          err => {
            reject(null);
          }
        );
      }
    });
  }

  /**
   * Cerco una categoria in base alla chiave, tra tutte le tipologie
   * @param idTypePoi 
   * @param findCategoryKey 
   */

  findCategories( findCategoryKey:string) {
    return new Promise((resolve, reject) => {

      console.log('findCategories');

      this.getAllCategories().then( (res:any) => {
        let allCategories = [];

        if ( res ) {
          res.forEach(element => {
            allCategories = allCategories.concat( element );
          });
        }

        const index = allCategories.findIndex(
          x => x.id === findCategoryKey
        );
        
        if (index !== -1) {
          resolve( allCategories[index] );
        } else {
          reject();
        }
      });


    });
    
  }


  loadFromCache(path) {

    this.cache.enableCache(true);
    this.cache.setDefaultTTL(60 * Constants.TTL_MULTI_TENANT );

    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });
    let options = { headers: headers };
    let cacheKey = path + '&' + this.translateService.currentLang;
    let request = this.httpClient.get(path, options);

    return this.cache.loadFromObservable(cacheKey, request);
  }

  changeLanguage(lang) {
    return new Promise(resolve => {

      this.translateService.use(lang);
      this.storage.set('lang', lang).then(res => {
        resolve(res);
      });

    });
  }


  getUserLanguage() {
    return new Promise(resolve => {

      let userLang = Constants.LANGUAGE.DEFAULT;
      this.storage.get('lang').then(
        result => {
          if (result) {
            userLang = result;
          } else {
            userLang = Constants.LANGUAGE.DEFAULT;
            this.storage.set('lang',userLang );
          }          
          this.translateService.use(userLang);
          resolve(userLang);

        },
        error => {
          console.log('STORAGE ' + error);

          userLang = Constants.LANGUAGE.DEFAULT;
          this.translateService.use(userLang);
          resolve(userLang);
        });


    });
  }

}
